import React, { useMemo } from 'react';

import { useStatsigClient } from '@statsig/react-bindings';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Logo } from '../../../../../../assets/icons/v3/betterfly-logo-white.svg';
import { ReactComponent as CalendarDots } from '../../../../../../assets/icons/v3/calendar-dots.svg';
import BdsButton from '../../../../../../shared/components/v3/Buttons/BdsButton/BdsButton';
import { DOWNLOAD_ICON } from '../../../../../../shared/constants/images';
import { CAN_DOWNLOAD_HEALTH_REPORTS_FG } from '../../../../../../shared/constants/statsig';
import { IHealthReportList } from '../../../../../../shared/interfaces/reports';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';
import { GenericVoidFunction } from '../../../../../../shared/types/genericTypes';
import { getLocalizedMonthName } from '../../../../../../shared/utils/utils';
import './ReportHeader.scss';

export const ReportHeader = ({
  reportList,
  downloadReport
}: {
  reportList: IHealthReportList;
  downloadReport: GenericVoidFunction;
}) => {
  const { t } = useTranslation();
  const { client } = useStatsigClient();

  const checkDownloadReportGate = useMemo(() => client?.checkGate(CAN_DOWNLOAD_HEALTH_REPORTS_FG), [client]);

  const getDateRange = () => {
    const endDate = new Date(reportList.endDate + 'T00:00:00');
    const startDate = new Date(reportList.dateStartHealth + 'T00:00:00');
    return `${getLocalizedMonthName(startDate.getMonth() + 1)} ${startDate.getFullYear()} - ${getLocalizedMonthName(
      endDate.getMonth() + 1
    )} ${endDate.getFullYear()}`;
  };

  return (
    <div className="health-report-welcome">
      <div className="health-report-top-bar">
        <Logo className="report-logo" />
        {checkDownloadReportGate && (
          <div className="only-landing">
            <BdsButton action={downloadReport} variant="primaryInverse" size="s" iconLeft={DOWNLOAD_ICON}>
              {t(TRANSLATIONS_REPORTS.healthReport.header.downloadReportButton)}
            </BdsButton>
          </div>
        )}
      </div>
      <div className="report-header">
        <div className="report-header-dates">
          <CalendarDots className="report-header-dates-icon" />
          <span>{getDateRange()}</span>
        </div>
        <div className="health-report-title">{t(TRANSLATIONS_REPORTS.healthReport.header.title)}</div>
        <div className="health-report-description">{t(TRANSLATIONS_REPORTS.healthReport.header.description)}</div>
      </div>
    </div>
  );
};

export default ReportHeader;
